__webpack_require__.p = "/web-cms-assets/_next/";